import DOMPurify from "dompurify";

/**
 * Sanitizes an HTML string so it can be safely rendered via v-html.
 *
 * Removes all potentially dangerous content (script tags, event handlers,
 * javascript: URLs, etc.) while keeping normal formatting HTML intact.
 *
 * Returns an empty string for null/undefined input.
 */
export function sanitizeHtml(html: string | null | undefined): string {
    if (!html) {
        return "";
    }
    return DOMPurify.sanitize(html);
}